import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import GetOrderResponse from '../model/get-order-response'

export default async function getOrder(orderId: string) {
  const response = await httpClient.post<GetOrderResponse>(resolveApiUrl('@sd-orders'), {
    json: graphql(`
      query {
        orderById(id: "${orderId}") {
          id
          createdAt
          staffId
          clientId
          status
          serviceIds
          services {
            id
            workload
            template {
              name
            }
          }
          totalPrice {
            amount
            currency
          }
          totalReward {
            amount
            currency
          }
          staffArrivalTime
          address
        }
      }
    `),
  })

  const responseBody = await response.json()
  return responseBody.data.orderById
}
